import { useState } from "react";
import { App } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { usePushSubscription } from "../../hooks/usePushSubscription";
import PushModalShell from "./PushModalShell";

interface PushSubscribersModalProps {
  open: boolean;
  onClose: () => void;
}

// Ниво „общ акаунт" (екранът с кода): списък на абонираните за известия на
// ТОВА устройство, само с премахване — никакво добавяне на хора оттук.
export default function PushSubscribersModal({
  open,
  onClose,
}: PushSubscribersModalProps) {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const push = usePushSubscription(open);
  const [removingUserId, setRemovingUserId] = useState<number | null>(null);

  const handleRemove = async (userId: number) => {
    if (removingUserId !== null) return;
    setRemovingUserId(userId);
    try {
      await push.removeSubscriber(userId);
    } catch (error) {
      console.error("Push subscriber removal error:", error);
      message.error(t("push.removeError"));
    } finally {
      setRemovingUserId(null);
    }
  };

  return (
    <PushModalShell
      open={open}
      onClose={onClose}
      title={t("push.deviceTitle")}
      subtitle={t("push.deviceSubtitle")}
      closeLabel={t("common.close")}
    >
      {push.loading ? (
        <div className="flex items-center justify-center py-6 text-[18px] text-muted">
          <LoadingOutlined spin />
        </div>
      ) : push.subscribers.length === 0 ? (
        <p className="m-0 text-[13px] font-medium leading-[1.5] text-body">
          {t("push.deviceEmpty")}
        </p>
      ) : (
        <div className="rounded-xl border border-shade-2">
          {push.subscribers.map((subscriber) => (
            <div
              key={subscriber.userId}
              className="flex items-center justify-between gap-3 border-b border-shade-2 px-3.5 py-2.5 last:border-b-0"
            >
              <span className="min-w-0 truncate text-[13.5px] font-semibold text-ink">
                {subscriber.name}
              </span>
              <button
                type="button"
                onClick={() => handleRemove(subscriber.userId)}
                disabled={removingUserId !== null}
                className="flex h-[30px] shrink-0 cursor-pointer items-center rounded-md border border-shade-3 bg-transparent px-2.5 text-[12px] font-semibold text-body transition-colors duration-150 hover:border-danger-ink/40 hover:bg-danger-tint hover:text-danger-ink disabled:opacity-50"
              >
                {removingUserId === subscriber.userId ? (
                  <LoadingOutlined spin />
                ) : (
                  t("push.remove")
                )}
              </button>
            </div>
          ))}
        </div>
      )}
    </PushModalShell>
  );
}
